<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> MODALIDADE DE PAGAMENTO </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title v-if="method.id"
          >{{ method.id }} - {{ method.name.toUpperCase() }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="4">
              <v-text-field
                v-model="method.name"
                class="text-field-uppercase"
                label="Nome"
                dense
                outlined
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="8"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-switch
                v-model="method.status"
                :label="`Status: ${getLabelStatus(method.status)}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn color="blue darken-3" dark class="mt-5" @click="validate">
                <v-icon left>mdi-send</v-icon> Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
import { URL } from "@/api/config";
export default {
  components: {},
  data: () => ({
    loading: false,
    method: {
      id: "",
      name: "",
      status: 1,
    },
    valid: true,
    lazy: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
  }),
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id) {
        this.getPaymentMethod(this.$route.params.id);
      }
    },
    async getPaymentMethod(id) {
      // this.showLoading();
      this.loading = true;
      try {
        let response = await fetch(`${URL}payment-method/${id}`);
        this.method = await response.json();
      } catch (error) {
        this.method = {};
        console.log(error);
        //this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    goToBackList() {
      this.$router.push({ name: "PaymentMethod" });
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.method.name = this.method.name.toUpperCase();
        this.method.status = this.method.status ? 1 : 0;
        let data = new URLSearchParams(this.method);
        if (this.method.id === "") {
          this.post(data);
        } else {
          this.update(this.method.id, data);
        }
      }
    },
    async post(data) {
      // this.showLoading();
      this.loading = true;
      try {
        let res = await fetch(`${URL}payment-method`, {
          method: "POST",
          body: data,
        });
        if (res) {
          // this.showAlert({
          //   message: "Tipo de Fornecedor salvo com sucesso",
          //   type: "success",
          // });
          this.goToBackList();
        }
      } catch (error) {
        console.log(error);
        // this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    async update(id, data) {
      this.loading = true;
      try {
        let res = await fetch(`${URL}payment-method/${id}`, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
          method: "PUT",
          body: data,
        });
        if (res) {
          // this.showAlert({
          //   message: "Tipo de Fornecedor atualizado com sucesso",
          //   type: "success",
          // });
          this.goToBackList();
        }
      } catch (error) {
        console.log(error);
        // this.showAlert({ message: error.message, type: "error" });
      } finally {
        this.loading = false;
        // this.hideLoading();
      }
    },
    getLabelStatus(status) {
      return status == 1 ? "Ativo" : "Desativado";
    },
  },
};
</script>
<style>
.text-field-uppercase input {
  text-transform: uppercase;
}
</style>
